export default __webpack_public_path__ + "static/media/P3000.7c8995eb.jpg";